import { Component, Input } from '@angular/core';

/**
 * The frame every sign-in page sits in: artwork with the logo on the left
 * (a short band on phones), the form card on the right.
 */
@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  styleUrls: ['./auth-shell.component.scss'],
  standalone: false,
})
export class AuthShellComponent {
  /** Line under the logo on the artwork. */
  @Input() tagline = 'Build worlds. Gather your party. Play.';
  readonly year = new Date().getFullYear();
}
